import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var JustificationStyle = /** @class */ (function (_super) {
    __extends(JustificationStyle, _super);
    function JustificationStyle() {
        return _super.call(this) || this;
    }
    JustificationStyle.forceNativeConstructor = true;
    JustificationStyle.forceNativeMethods = true;
    // JS -> AS Bindings
    JustificationStyle.PUSH_IN_KINSOKU = 'pushInKinsoku';
    JustificationStyle.PUSH_OUT_ONLY = 'pushOutOnly';
    JustificationStyle.PRIORITIZE_LEAST_ADJUSTMENT = 'prioritizeLeastAdjustment';
    return JustificationStyle;
}(ASObject));
export { JustificationStyle };
